var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgGreenArrowRoundDown = function SvgGreenArrowRoundDown(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#49C092",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "M4 5.999A9.956 9.956 0 0 0 2 12c0 5.523 4.477 10 10 10s10-4.477 10-10S17.523 2 12 2a9.966 9.966 0 0 0-4 .832"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#49C092",
    strokeLinecap: "round",
    strokeWidth: 1.5,
    d: "m8.8 10.7 2.517 2.71a1 1 0 0 0 1.466 0L15.3 10.7"
  })));
};
export default SvgGreenArrowRoundDown;